import i18next from 'i18next';
import { isSupportedLanguage } from '@/i18n/supportedLanguages';
import { readStoredLanguage, storeLanguage } from '@/lib/languageStorage';

export async function applyAccountLanguage(preferredLanguage: string): Promise<void> {
  if (readStoredLanguage() !== null || isSupportedLanguage(preferredLanguage) === false) {
    return;
  }
  storeLanguage(preferredLanguage);
  if (i18next.language !== preferredLanguage) {
    await i18next.changeLanguage(preferredLanguage);
  }
}
